import React, {useEffect, useRef, useState} from "react";

export function VideoPage({type, skip}) {

	let [containerWidth, setContainerWidth] = useState();
	const container = useRef()
	useEffect(() => setContainerWidth(container.current && container.current.getBoundingClientRect().width),[container])
	useEffect(() => {if (!type.video) skip()})

		return <div ref={container}>
			{containerWidth &&
				<video autoPlay muted onClick={() => skip()} width={containerWidth}>
				<source src={type.video} type={"video/mp4"} alt={type.name}/>
			</video>
			}
		</div>
}
